import axiosInstance from '@/services/axiosInstance';
import type { InvoicePayload } from './types';

export async function createInvoice(payload: InvoicePayload) {
    const response = await axiosInstance.post('/api/v1/invoices', payload, {
        responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    try {
        window.open(url);
    } catch {
        const link = document.createElement('a');
        link.href = url;
        link.download = `invoice-${payload.invoice.number}.pdf`;
        link.click();
    }
}
